<template>
  <div>
    <div class="button">
      <el-button @click="$router.go(-1)">返回上一页</el-button>
    </div>
    <div class="container">
      <el-table
        :data="tableData"
        border
        style="width: 100%">
        <el-table-column
          prop="id"
          align="center"
          label="核销批次">
        </el-table-column>
        <el-table-column
          prop="spuName"
          align="center"
          label="核销油品">
        </el-table-column>
        <el-table-column
          prop="billTotalAmount"
          align="center"
          label="账单总金额">
        </el-table-column>
        <el-table-column
          prop="createTime"
          align="center"
          label="提交时间">
        </el-table-column>
        <el-table-column
          prop="updateTime"
          align="center"
          label="更新时间">
        </el-table-column>
        <el-table-column
          prop="verificationTypeStr"
          align="center"
          label="提交内容">
        </el-table-column>
        <el-table-column
          prop="verificationStatusStr"
          align="center"
          label="提交结果">
        </el-table-column>
        <el-table-column
          prop="invoiceCode"
          align="center"
          label="发票代码">
        </el-table-column>
        <el-table-column
          prop="invoiceNo"
          align="center"
          label="发票号码">
        </el-table-column>
        <el-table-column
          prop="applaySourceStr"
          align="center"
          label="提交入口">
        </el-table-column>
        <el-table-column
          prop="confirmMethodStr"
          align="center"
          label="确认方式">
        </el-table-column>
        <el-table-column
          align="center"
          label="操作">
          <template slot-scope="scope">
            <el-button @click="handleDetail(scope.row)" type="text" size="small">账单信息</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="pagination.pageIndex"
          :page-sizes="[10, 20, 30, 40, 50]"
          :page-size="pagination.pageSize"
          layout="total, sizes, prev, pager, next"
          :total="total">
        </el-pagination>
      </div>
    </div>
    <el-dialog
      title="账单信息"
      width="60%"
      :visible.sync="visible">
      <el-table
        :data="infoTableData"
        border
        style="width: 100%">
        <el-table-column
          prop="id"
          align="center"
          label="结算单ID">
        </el-table-column>
        <el-table-column
          prop="billDay"
          align="center"
          label="账单日期">
        </el-table-column>
        <el-table-column
          prop="gasName"
          align="center"
          label="油站">
        </el-table-column>
        <el-table-column
          prop="oilSpuName"
          align="center"
          label="油品">
        </el-table-column>
        <el-table-column
          prop="invoiceAmount"
          align="center"
          label="油站应开发票总金额(元)">
        </el-table-column>
        <el-table-column
          prop="signBodyName"
          align="center"
          label="签约主体">
        </el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination
          @current-change="handleInfoChange"
          :current-page.sync="infoPagination.pageIndex"
          :page-size="infoPagination.pageSize"
          layout="total, prev, pager, next"
          :total="infoTotal">
        </el-pagination>
      </div>
    </el-dialog>
  </div>
</template>
<script>
  import { writeOffRecords, billingInformation } from '@/api/finance'

  export default {
    data () {
      return {
        tableData: [],
        pagination: {
          pageSize: 10,
          pageIndex: 1
        },
        total: 0,
        visible: false,
        infoTableData: [],
        infoPagination: {
          pageSize: 10,
          pageIndex: 1
        },
        infoTotal: 0,
        id: null
      }
    },
    methods: {
      async initData () {
        const { code, result, totalRow } = await writeOffRecords(this.pagination)
        if (code !== 200) return
        this.tableData = result
        this.total = totalRow
      },
      handleSizeChange (val) {
        this.pagination.pageSize = val
        this.initData()
      },
      handleCurrentChange (val) {
        this.pagination.pageIndex = val
        this.initData()
      },
      async handleDetail (row) {
        this.id = row.id || this.id
        this.visible = true
        const { code, result, totalRow } = await billingInformation({ ...this.infoPagination, id: this.id })
        if (code !== 200) return
        this.infoTableData = result
        this.infoTotal = totalRow
      },
      handleInfoChange (val) {
        this.infoPagination.pageIndex = val
        this.handleDetail()
      }
    },
    created () {
      this.initData()
    }
  }
</script>
<style lang="less" scoped>
  .button {
    margin: 30px 0 20px 0;
    text-align: right;
  }
  .container {
    background-color: #fff;
    padding: 20px;
  }
  .pagination {
    margin-top: 20px;
    text-align: right;
  }
</style>
